import { Splide } from '@splidejs/splide';

export default () => {
	const sections = document.querySelectorAll('.difference');

	sections.forEach(function(section) {
		const slider = section.querySelector('.splide');

		if (slider) {
			const splide = new Splide(slider, {
				// focus  : 'center',
				gap: 12,
				speed: 500,
				arrows: false,
				pagination: false,
				type: 'loop',
				autoWidth: true,
				mediaQuery: 'min',
				drag: 'free',
				breakpoints: {
					744: {
						destroy: true,
					},
				}
			}).mount();
		}
	});
}